import * as React from 'react';

import {Modal} from 'shells/modal/modal';

import {ScheduledEmailEdit} from './scheduled-email-edit';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    scheduledEmailId: string;
};

export class ScheduledEmailEditModal extends React.PureComponent<Props> {
    render() {
        const {isOpen, ...restProps} = this.props;

        return (
            <Modal
                headerText='Edit email'
                isWide={true}
                isOpen={isOpen}
                canClickOutsideToClose={false}
                onClose={this.handleClose}
                waitForMount={true}
            >
                <ScheduledEmailEdit {...restProps} />
            </Modal>
        );
    }

    handleSubmitSuccess = () => {
        Timeline.refreshTimeline();

        this.props.onClose();
    };

    handleClose = () => {
        // Check to see if modal is open, because if coming through a form submission,
        // this will have already occurred.
        if (this.props.isOpen) {
            this.props.onClose();
        }
    };
}
